import { createContext, useContext } from 'react';
import * as defaultApi from '../../utils/grirApi';
import { sendGRIRMessage } from '../../utils/grirChatApi';

export const GrirApiContext = createContext({ ...defaultApi, sendGRIRMessage });
export const useGrirApi = () => useContext(GrirApiContext);
